import ApiService from '../../../shared/services/ApiService';

export default {

    changePassword(data) {
        return  ApiService.post('/change-password', data)
    },

    updateUserName(data){
        return ApiService.post('/user-change-name', data)
    },

    uploadImage(data){
        return ApiService.post('/upload-image', data)
    },

    deleteImage(){
        return ApiService.get('/delete-image')
    },

    getAuthUser(){
        return ApiService.get('user')
    },

    requestChangeEmail(data){
        return ApiService.post('request-change-email', data)
    },

    resendVerificationEmail() {
        return ApiService.get('resend-change-email')
    },

    cancelChangeEmailRequest() {
        return ApiService.get('cancel-change-email')
    },

    checkUserOldPassword(data){
        return ApiService.post('check-old-password', data);
    },

    saveUserSettings(data){
        return ApiService.post('user-settings', data);
    },

    uploadUserLicenseImages(data){
        return ApiService.post('upload-license-images', data)
    },

    saveLicenseNumber(data){
        return ApiService.post('license-number', data)
    },

    getDownloadMemberLicense(memberId){
        const date = new Date();
        const time = date.getMilliseconds();
        return ApiService.downloadFile(`/download-member-license?member_id=${memberId}&time=${time}`);
    },

    resendActivateAccount(data){
        return ApiService.post('resend-activate-account', data)
    },
}